import { render, staticRenderFns } from "./chart-config.vue?vue&type=template&id=8e81900a"
import script from "./chart-config.vue?vue&type=script&lang=js"
export * from "./chart-config.vue?vue&type=script&lang=js"
import style0 from "./chart-config.vue?vue&type=style&index=0&id=8e81900a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports